import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTelegramFill = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M14.115 6.222q-2.687 1.117-10.74 4.626-1.308.52-1.37 1.017c-.07.56.631.782 1.587 1.082q.196.061.403.128c.94.306 2.205.663 2.863.678q.894.019 1.997-.738 7.524-5.079 7.768-5.134c.115-.026.273-.06.381.037.108.095.097.277.086.325-.07.297-2.825 2.858-4.25 4.183-.445.413-.76.707-.825.774-.144.15-.291.291-.433.428-.873.842-1.528 1.473.037 2.505.752.495 1.354.905 1.954 1.314.656.446 1.31.892 2.156 1.446q.322.215.622.431c.763.544 1.448 1.033 2.295.955.492-.045 1-.508 1.259-1.888.61-3.262 1.809-10.328 2.086-13.24a3.3 3.3 0 0 0-.03-.725c-.025-.143-.076-.348-.263-.499-.22-.179-.561-.217-.713-.214-.693.012-1.756.382-6.87 2.509'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTelegramFill)
export default ForwardRef
